module.exports = __webpack_public_path__ + "img/equipment.adfe79be.png";